import styled from "styled-components"
import EditIcon from "@mui/icons-material/Edit"
import colors from "~constants/colors"
import DeleteIcon from "@mui/icons-material/Delete"

interface UserDetailActionsProps {
  onEdit: () => void
  onDelete: () => void
  compact?: boolean
}

const UserDetailActions = ({
  onEdit,
  onDelete,
  compact = false,
}: UserDetailActionsProps) => {
  return (
    <ActionsRow>
      <IconBtn
        onClick={onEdit}
        tabIndex={0}
        title="Edit user"
        $compact={compact}
      >
        <EditIcon style={{ fontSize: compact ? 16 : 18 }} />
      </IconBtn>
      <IconBtn
        onClick={onDelete}
        tabIndex={0}
        $danger
        title="Delete user"
        $compact={compact}
      >
        <DeleteIcon style={{ fontSize: compact ? 16 : 18 }} />
      </IconBtn>
    </ActionsRow>
  )
}

const ActionsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
`

const IconBtn = styled.button<{ $danger?: boolean; $compact?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ $compact }) => ($compact ? "30px" : "34px")};
  height: ${({ $compact }) => ($compact ? "30px" : "34px")};
  border-radius: ${({ $compact }) => ($compact ? "7px" : "8px")};
  border: 1px solid ${colors.gray2};
  background: ${colors.white};
  cursor: pointer;
  color: ${({ $danger }) => ($danger ? colors.red : colors.gray6)};
  transition:
    background 0.15s ease,
    color 0.15s ease,
    border-color 0.15s ease;

  &:hover {
    background: ${({ $danger }) => ($danger ? "#FFF0F1" : colors.gray1)};
    color: ${({ $danger }) => ($danger ? colors.red3 : colors.blue1)};
    border-color: ${({ $danger }) => ($danger ? colors.red2 : colors.gray2)};
  }

  &:focus-visible {
    outline: 2px solid ${colors.blue1};
    outline-offset: 2px;
  }
`

export default UserDetailActions
